import { DEFAULT_LOCALE, useLocaleData } from 'components/intl-provider/intl-provider.hooks';

import React from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';

interface IntlProviderProps {
  children: React.ReactNode;
}

export const IntlProvider: React.FC<IntlProviderProps> = ({ children }: IntlProviderProps): JSX.Element => {
  const { locale, messages } = useLocaleData(navigator.language.toLowerCase());

  return (
    <ReactIntlProvider messages={messages} locale={locale} defaultLocale={DEFAULT_LOCALE}>
      {children}
    </ReactIntlProvider>
  );
};
